import * as React from 'react';
import { UsefulLinksWidget } from '../../../CoreComponents/UsefulLinksWidget';
import PayrollReportingGenerationWidget from '../../../PayrollComponents/Widgets/PayrollReportingGenerationWidget';
import { GetSettings } from '../../../../functions/StateManagement/StateStorageFunctions';
import { RenderSettings } from '../../../../interfaces/WidgetSettingsInterfaces';
import { DashboardOrganizationState } from '../../interfaces';
import { SelectOptions } from '../../../../interfaces/CoreInterfaces';
import DashboardHeaderRow from '../../../CoreComponents/DashboardHeaderRow';
import { DashboardOrganizer } from '../../../../functions/WidgetDashboardOrganizer';

export default class PayrollDashboard extends React.Component<{}, DashboardOrganizationState>
{

  settingsString: string = "payrollDashboard";

  constructor(props: {}) {
    super(props);
    let settings: RenderSettings = GetSettings<RenderSettings>(this.settingsString);
    if (settings == null) {
      settings = {
        rows: [
          {
            col: 2,
            widgets: [1, 0]
          },
          {
            col: 1,
            widgets: [2]
          }
        ]
      }
    }
    this.state = {
      widgetList: [], // Needs to be preset
      displayWidgets: [],
      renderSettings: settings
    }
    this.updateUI = this.updateUI.bind(this);
  }

  async componentDidMount(): Promise<void> {

  }

  async prepareDashboard(): Promise<void> {
    let tabList: { [key: number]: JSX.Element } = {
      0: <UsefulLinksWidget />,
      1: <PayrollReportingGenerationWidget />,
      2: <UsefulLinksWidget />
    }
    let widgetList: Array<SelectOptions> = [ 
      { label: "Useful Links", value: "0" },
      { label: "Payroll Reporting Generation", value: "1" }
    ]
  }

  updateUI(settings: RenderSettings): void {
    this.setState({ renderSettings: settings })
  }

  render(): JSX.Element
  {
    return (
      <>
        <DashboardHeaderRow dashboardTitle="Payroll Dashboard" settingsString={this.settingsString} displayList={this.state.displayWidgets} widgetList={this.state.widgetList} updateUI={this.updateUI} />
        {DashboardOrganizer(this.state.displayWidgets, this.state.renderSettings)}
      </>
    )
  }
}